import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import useTheme from '@hero/branding/theme';
import * as styles from './markLayout.module.css';

export const useMarkThemeStyles = (): React.CSSProperties => {
    const { colors } = useTheme();
    return {
        '--mark-text': colors.neutrals.textAlpha,
        '--mark-muted': colors.neutrals.textBeta,
        '--mark-surface': colors.neutrals.background,
        '--mark-border': colors.neutrals.borderBeta,
        '--mark-primary': colors.brand.primary.alpha,
        '--mark-selected': colors.brand.primary.epsilon,
        '--mark-danger': colors.status.fail.alpha,
        '--mark-danger-surface': colors.status.fail.epsilon,
        '--mark-warning': colors.status.warn.alpha,
        '--mark-warning-surface': colors.status.warn.epsilon,
        '--mark-success': colors.status.success.alpha,
        '--mark-success-surface': colors.status.success.epsilon
    } as React.CSSProperties;
};

export const MarkPageHeader: React.FC<{
    title: string;
    description?: string;
    children?: React.ReactNode;
}> = ({ title, description, children }) => (
    <header className={styles.pageHeader}>
        <div className={styles.headerCopy}>
            <H role="h4" styles={{ margin: 0 }}>
                {title}
            </H>
            {description && (
                <P noDefaultMargin styles={{ color: 'var(--mark-muted)', marginTop: '0.8rem' }}>
                    {description}
                </P>
            )}
        </div>
        {children && <div className={styles.actions}>{children}</div>}
    </header>
);

export const MarkEmptyState: React.FC<{
    title: string;
    description: string;
    children?: React.ReactNode;
}> = ({ title, description, children }) => (
    <Section
        border
        noDefaultPadding
        className={styles.emptyState}
        styles={{ borderColor: 'var(--mark-border)' }}
    >
        <P noDefaultMargin strong>
            {title}
        </P>
        <P noDefaultMargin styles={{ color: 'var(--mark-muted)', maxWidth: '56rem' }}>
            {description}
        </P>
        {children && <div className={styles.actions}>{children}</div>}
    </Section>
);
